export const PARALLAX_CONSUMER_CLASS_NAME = 'parallax-consumer';
export const PARALLAX_DEFAULT_SPEED = -5;
